import api from '../../api/index.js'

const state = {

}

const getters = {

}

const actions = {
    // 获取预约代祭商品集合
    GetProductProductSearchList({commit},payload){
        return new Promise((resolve,reject) => {
            api.get('/Product/ProductSearch',payload, res => {
                resolve(res.Result)
            }, err => {
                reject(err)
            }) 
        });
    },
    // 获取预约代祭商品详情
    GetProductProductDetail({commit},payload){
        return new Promise((resolve,reject) => {
            api.get('/Product/GetProductDetail',payload, res => {
                resolve(res.Result)
            }, err => {
                reject(err)
            }) 
        });
    },
}

const mutations = {

}

export default {
    state,
    getters,
    actions,
    mutations
}




